import { FilterMatchMode } from 'primereact/api';

export const tableFilters = {
  playa: { value: null, matchMode: FilterMatchMode.CONTAINS },
  armador: { value: null, matchMode: FilterMatchMode.CONTAINS },
  contenedor: { value: null, matchMode: FilterMatchMode.CONTAINS },
  tipoDeContenedor: { value: null, matchMode: FilterMatchMode.CONTAINS },
  tamano: { value: null, matchMode: FilterMatchMode.CONTAINS },
  fechaAbierto: { value: null, matchMode: FilterMatchMode.DATE_IS },
  motivo: { value: null, matchMode: FilterMatchMode.CONTAINS },
  viajeImport: { value: null, matchMode: FilterMatchMode.CONTAINS },
  origen: { value: null, matchMode: FilterMatchMode.CONTAINS },
  fechaLlegada: { value: null, matchMode: FilterMatchMode.DATE_IS },
  imoImport: { value: null, matchMode: FilterMatchMode.CONTAINS },
  viajeExport: { value: null, matchMode: FilterMatchMode.CONTAINS },
  destino: { value: null, matchMode: FilterMatchMode.CONTAINS },
  booking: { value: null, matchMode: FilterMatchMode.CONTAINS },
  precinto1: { value: null, matchMode: FilterMatchMode.CONTAINS },
  precinto2: { value: null, matchMode: FilterMatchMode.CONTAINS },
  precinto3: { value: null, matchMode: FilterMatchMode.CONTAINS },
  precinto4: { value: null, matchMode: FilterMatchMode.CONTAINS },
  exportador: { value: null, matchMode: FilterMatchMode.CONTAINS },
  imoExport: { value: null, matchMode: FilterMatchMode.CONTAINS },
  fechaSalida: { value: null, matchMode: FilterMatchMode.DATE_IS },
};
